import { render, staticRenderFns } from "./PopupSharerStats.vue?vue&type=template&id=44dd61b6"
import script from "./PopupSharerStats.vue?vue&type=script&lang=js"
export * from "./PopupSharerStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports